"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:6.1.2'] && _();
}
catch (e) { }
